<template>
    <div class="flex items-center gap-4 rounded-lg bg-gray-50 p-5" data-test-id="reviews-empty-state">
        <MessageSquareIcon class="size-8 shrink-0 text-gray-400" :stroke-width="1.5" />

        <div class="flex flex-col gap-1">
            <p class="font-bold" v-text="t('general.reviews.no_reviews_title')" />
            <p
                v-if="formattedRating && votes"
                class="text-sm text-gray-500"
                v-text="t('general.reviews.no_reviews_description', { rating: formattedRating, votes }, votes)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { MessageSquareIcon } from '@lucide/vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();
const productPageStore = useProductPageStore();

const votes = computed((): number => productPageStore.lipscoreProduct?.votes ?? 0);

// Shows 4,4 or 4.4 depending on the store language
const formattedRating = computed((): string | undefined => {
    const rating = productPageStore.lipscoreProduct?.rating;

    if (!rating) {
        return undefined;
    }

    return new Intl.NumberFormat(String(locale.value).replace('_', '-'), { maximumFractionDigits: 1 }).format(rating);
});
</script>
